module.exports = __webpack_public_path__ + "img/img_skin_3.15c62c32.png";